import React from 'react'
import { TABLA_BODEGA_BUQUE } from '../../../config/tables'
import MuiTable from '../../Forms/SharedComponents/containers/MuiTable'

function BodegasBuqueView () {
  return <MuiTable id={TABLA_BODEGA_BUQUE} />
}

export default BodegasBuqueView
